export enum RigidBodyTypesNames {
  Dynamic = 'dynamic',
  Fixed = 'fixed',
  KinematicPositionBased = 'kinematicPositionBased',
  KinematicVelocityBased = 'kinematicVelocityBased'
}
